import moment from "moment-timezone";
import React from "react";
import ClassModel from "src/models/ClassModel";
import OfferingModel from "src/models/OfferingModel";
import { useStore } from "src/stores/Store";
import { dateFormatMed } from "src/utils/constants";
import shortenClassTimes from "src/utils/shortenClassTimes";

interface Props {
  classItem: ClassModel | OfferingModel;
  handleExpandClick?: (e: any) => void;
  showInstructors?: boolean;
  timesOnly?: boolean;
  isPreview?: boolean;
}

export function ClassTimes(props: Props) {
  const store = useStore();

  if (!props.classItem) {
    return null;
  }

  const itemContent = [];
  const shortenedClassTimes = shortenClassTimes(props.classItem);

  shortenedClassTimes.forEach((sct, i) => {
    itemContent.push(
      <React.Fragment key={i}>
        <div className="text-sm">
          {!props.timesOnly && sct.days && !sct.date && (
            <strong>{sct.days}</strong>
          )}{" "}
          {sct.date && !props.timesOnly && (
            <strong>{moment(sct.date).format(dateFormatMed)}</strong>
          )}{" "}
          {sct.allDayPresentation && sct.allDayPresentation}
          {!sct.startTime &&
            !sct.endTime &&
            !sct.allDayPresentation &&
            props.timesOnly &&
            "All day"}
          {sct.startTime && !sct.endTime && "starting at "}
          {sct.startTime && sct.startTime}
          {sct.startTime && sct.endTime && "-"}
          {sct.endTime && sct.endTime}{" "}
          {store.userTimezone !== store.organization.timezone &&
            sct.startTime &&
            moment().tz(store.organization.timezone).format("z")}
          <div className="text-xs text-empty">
            {sct.location
              ? sct.location
              : sct.atAccountHome
                ? "Account holder’s address"
                : store.organization.title}
            {sct.zone && ` • ${sct.zone}`}
            {(!props.classItem.hideDefaultStaff ||
              (store.isAdminArea && !props.isPreview)) &&
              sct.instructor && <span> • {sct.instructor}</span>}
          </div>
        </div>
      </React.Fragment>
    );
  });

  if (props.classItem.location && props.classItem.classTimes.length === 0) {
    itemContent.push(
      <div key={itemContent.length}>
        <div>
          <strong>{props.classItem.location.title}</strong>
        </div>
        {props.classItem.zone && (
          <div className="text-xs text-empty">{props.classItem.zone.title}</div>
        )}
      </div>
    );
  }

  // console.log("itemContent", itemContent);

  if (itemContent.length === 0) {
    return null;
  }

  return <>{itemContent}</>;
}
